<script lang="ts">
    import { Img, Avatar } from "flowbite-svelte";
    import AbstractID, { userProfileAvailable } from "../AbstractID";
    import site from "../site";

    import { createEventDispatcher } from "svelte";

    const fnOnSignOut = () => {
        window.localStorage.removeItem('jwt2');

        setTimeout(() => (window.location.href = `${site.idBaseURL}/auth/verify?logout=true&app=${site.appID}&returnURL=${encodeURIComponent(site.baseURL)}`), 250);
    };

    export let compact = false;
    export let showLinks = true;
    export let clickable = true;

    const dispatcher = createEventDispatcher();

    let minimumCardHeight:number;
    $: {
        minimumCardHeight = compact ? 80 : 100;
    }
</script>

<!-- svelte-ignore a11y-no-static-element-interactions -->
<!-- svelte-ignore a11y-click-events-have-key-events -->
<div
    class="max-w-[100%] w-[270px] {clickable ? 'hover:ring cursor-pointer' : ''} mt-8 relative rounded-lg outline outline-offset-2 outline-1 outline-zinc-300 dark:outline-zinc-700 z-0 p-2 bg-[length:128px_128px]"
    style="min-height: {minimumCardHeight}px"
    on:click={() => dispatcher("click")}>
    <Img class="{compact ? 'max-h-[12px]' : 'max-h-[16px]'} text-center mx-auto dark:invert opacity-90" src="/AbstractID-Logo.png" />

    <div class="flex items-start space-x-2 align-top {compact ? 'mt-1' : 'mt-2'} -mb-1 zindex-10 relative">
        <Avatar class="shrink-0" src={$userProfileAvailable ? AbstractID.userProfilePictureURL : ""} rounded />
        <div class="font-medium text-gray-900 dark:text-white pb-1 w-full overflow-none">
            <div>{AbstractID.tokenData?.firstName} {AbstractID.tokenData?.lastName}</div>
            <div class="text-xs dark:text-gray-300">{AbstractID.tokenData?.email}</div>
        </div>
    </div>

    {#if showLinks}
        <div class="mt-4 text-center whitespace-nowrap text-sm text-gray-800 dark:text-gray-400">
            <div>
                <a class="font-bold hover:underline text-gray-700 dark:text-gray-400 hover:text-black dark:hover:text-white mr-2" href={site.idBaseURL} target="_blank">Account</a>
                <!-- svelte-ignore a11y-no-static-element-interactions -->
                <!-- svelte-ignore a11y-click-events-have-key-events -->
                <a class="font-bold cursor-pointer hover:underline text-gray-700 dark:text-gray-400 hover:text-black dark:hover:text-white" id="sign-out" on:click={fnOnSignOut}>
                    Sign Out
                </a>
            </div>
        </div>
    {/if}
    <div class="absolute bg-gradient-to-b from-zinc-100 to-zinc-200 dark:from-zinc-800 dark:to-zinc-700 w-full h-full rounded-lg top-0 left-0" style="z-index: -1" />
    <div class="absolute bg-repeat opacity-30 w-full h-full rounded-lg dark:invert top-0 left-0" style="z-index: -1;background-image: url('/AbstractID-Tile-Dark.png')" />
</div>
